<template>
  <v-tooltip
    :model-value="show"
    :location="position"
    transition="fade-transition"
    :attach="attach"
    content-class="datapeople-tooltip"
    :max-width="maxWidth"
    :offset="offset"
    @update:model-value="handleModelValueUpdate"
  >
    <template #activator="{ props }">
      <div
        class="enhanced-tooltip-activator"
        v-bind="props"
      >
        <slot name="activator" />
      </div>
    </template>
    <div
      class="enhanced-tooltip-content"
      @mouseleave="hoverOutside($event); hoveredContent = false;"
      @mouseenter="hoveredContent = true"
      @click="handleContentClick"
    >
      <slot />
    </div>
  </v-tooltip>
</template>

<script>
import { mapState } from 'pinia';
import { useAppBase } from '@/stores/app/base';

/* DpplEnhancedTooltip opens on hover and
closes when hovered outside of both the content and activator elements */
export default {
  name: 'DpplEnhancedTooltip',
  props: {
    attach: { type: [String, Boolean], default: false },
    position: { type: String, default: 'start' },
    offset: { type: Number, default: 10 },
    maxWidth: { type: String, default: '208px' },
    closeOnContentClick: { type: Boolean, default: false },
  },
  data() {
    return {
      show: null,
      hoveredContent: false,
      hoveredActivator: false,
    };
  },
  computed: {
    ...mapState(useAppBase, ['frameScrollTop']),
  },
  watch: {
    // Close the tooltip on frame scroll
    frameScrollTop() {
      this.show = null;
      this.hoveredActivator = false;
      this.hoveredContent = false;
    },
  },
  methods: {
    handleContentClick() {
      if (this.closeOnContentClick) {
        this.show = null;
      }
    },
    handleModelValueUpdate(isActive, event) {
      if (isActive) {
        this.handleShowDelay();
      } else {
        this.hoverOutside(event);
        this.hoveredActivator = false;
      }
    },
    handleShowDelay() {
      this.hoveredActivator = true;

      setTimeout(() => {
        if (this.hoveredActivator) {
          this.show = true;
        }
      }, 250);
    },
    // Closes tooltip if content and activator are not hovered
    hoverOutside(event) {
      if (!event && !this.hoveredContent) {
        this.show = null;
        return;
      }

      const { classList = [] } = event?.target || {};

      setTimeout(() => {
        // Spread operator to convert from DOMTokenList to Array
        if ([...classList].includes('enhanced-tooltip-content') && !this.hoveredActivator) {
          this.show = null;
        } else if ([...classList].includes('enhanced-tooltip-activator') && !this.hoveredContent) {
          this.show = null;
        }
      }, 50);
    },
  },
};
</script>

<style lang="less" scoped>
.v-tooltip > :deep(.v-overlay__content.datapeople-tooltip) {
  box-shadow: 0px 0px 50px fade(@text-darkest, 10%);
  background: @white;
  opacity: 1 !important;
  z-index: 10 !important;
  padding: 0px !important;
  width: v-bind(maxWidth);
  border-radius: 10px;
  color: @text-darkest;
  pointer-events: auto;
  text-align: center;

  :deep(span), :deep(p), :deep(strong) {
    font-size: 14px;
    line-height: 20px;
    text-align: center;
    font-weight: 300;
  }

  :deep(strong) {
    font-weight: 400;
  }
}

.enhanced-tooltip-content {
  padding: 24px;
}

.enhanced-tooltip-activator {
  cursor: pointer;
}
</style>
